import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/doppler-effect-calculator',
  component: () =>
    import('../../routes/DopplerEffectCalculator.svelte'),
  card: {
    id: 'doppler-effect-calculator',
    title: 'Doppler Effect',
    description:
      'Calculate the observed frequency of a moving source or observer using f = f₀ × (c + vₒ) / (c − vₛ). Works for sound, light, and any wave — supports radar guns, sirens, and redshift.',
    icon: 'graphic_eq',
    iconBgClass: 'bg-indigo-50',
    iconTextClass: 'text-indigo-600',
    href: '/doppler-effect-calculator',
    category: 'Physics & Science',
  },
  seo: {
    title:
      'Doppler Effect Calculator – Observed Frequency & Wavelength Shift',
    description:
      'Free Doppler effect calculator using f = f₀ × (c + vₒ) / (c − vₛ). Compute observed frequency, frequency shift, wavelength compression/dilation, and Mach number for any wave — sound, light, radar. Includes air, water, steel, and vacuum presets.',
  },
};

export default meta;